import React from 'react';

import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined';
import PropTypes from 'prop-types';

export const FilesList = ({ files, onFileRemove }) => {
  if (!files.length) {
    return null;
  }

  return (
    <div className="file-list">
      {files.map((file, index) => (
        <div className="file-item" key={file.name}>
          <InsertDriveFileOutlinedIcon fontSize="large" />
          <div className="file-item-bottom">
            <div className="file-info">{file.name}</div>
            <div className="file-actions">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onFileRemove(index);
                }}>
                <DeleteForeverOutlinedIcon />
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

FilesList.propTypes = {
  files: PropTypes.array.isRequired,
  onFileRemove: PropTypes.func.isRequired,
};
